<!-- 入库和调拨操作 -->
<template>
    <div class="container">
        <div class="content">
            <Form :model="formItem" label-position="right" :label-width="110">
                <FormItem label="选择条件：">
                    <RadioGroup v-model="formItem.type" type="button">
                        <Radio class="mr-24 mb-12" label="1">按产品名称批量入库</Radio>
                        <Radio class="mr-24 mb-12" label="2">按生成批次批量入库</Radio>
                        <Radio class="mr-24 mb-12" label="3">按所属代理批量入库</Radio>
                        <Radio class="mr-24 mb-12" label="4">录入码数据批量入库</Radio>
                        <Radio class="mr-24 mb-12" label="5">按ID号段批量入库</Radio>
                    </RadioGroup>
                </FormItem>
                <FormItem v-if="formItem.type == '1'" label="选择产品：">
                    <Select class="w300" v-model="formItem.product_id" clearable filterable placeholder="请选择要入库的产品">
                        <Option v-for="item in productList" :value="item.id" :key="item.id">{{ item.product_name }}</Option>
                    </Select>
                </FormItem>
                <FormItem v-if="formItem.type == '2'" label="选择批次：">
                    <Select class="w300" v-model="formItem.batch_id" clearable filterable placeholder="请选择要入库的批次">
                        <Option v-for="item in batchList" :value="item.id" :key="item.id">{{ item.batch_name }}</Option>
                    </Select>
                </FormItem>
                <FormItem v-if="formItem.type == '3'" label="选择代理：">
                    <Select class="w300" v-model="formItem.agent_id" clearable filterable placeholder="请选择代理商名称">
                        <Option v-for="item in agentList" :value="item.id" :key="item.id">{{ item.agent_name }}</Option>
                    </Select>
                </FormItem>
                <FormItem v-if="formItem.type == '5'" label="溯源码ID号段：">
                    <Input class="width_10 mr-24" type="text" v-model="formItem.start_id" placeholder="请输入起始ID"></Input>
                    <Input class="width_10" type="text" v-model="formItem.end_id" placeholder="请输入截止ID"></Input>
                </FormItem>
                <FormItem label="选择仓库：">
                    <Select class="w300" v-model="formItem.warehouse_id" clearable filterable placeholder="请选择要入库或调拨到哪个仓库">
                        <Option v-for="item in warehouseList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                    </Select>
                    <div v-if="formItem.type == '4'">
                        <Input class="w400 mt-24" search enter-button="搜索" placeholder="录入溯源码 支持 产品码|小箱码|大箱码，支持扫码枪" @on-search="searchInput"/>
                    </div>
                </FormItem>
                <div class="table_div" v-if="formItem.type == '4'">
                    <Table class="mt-24" :columns="columnsTable" :data="dataTable" border>
                        <template slot-scope="{ row }" slot="show_product_imgs">
                            <div class="flex-c" v-if="row.product">
                                <img class="width_60 mt-12 mb-12" v-if="row.product.product_imgs" :src="row.product.show_product_imgs[0]">
                                <img class="width_60 mt-12 mb-12" v-else src="../../assets/example.png">
                            </div>
                        </template>
                        <template slot-scope="{ row }" slot="product_name">
                            <div v-if="row.product">
                                <div>{{row.product.product_name}}</div>
                                <div>{{row.product.specs}}</div>
                            </div>
                        </template>
                        <template slot-scope="{ row }" slot="batch_name">
                            <div v-if="row.batch"><div>{{row.batch.batch_name}}</div></div>
                        </template>
                        <template slot-scope="{ row }" slot="box">
                            <div v-if="row.box"><div>{{row.box.qrcode_number}}</div></div>
                        </template>
                        <template slot-scope="{ row }" slot="warehouse_qrcode">
                            <div v-if="row.warehouse_qrcode"><div>{{row.warehouse_qrcode.warehouse.name}}</div></div>
                        </template>
                        <template slot-scope="{ row }" slot="status_text">
                            <div class="flex-c">
                                <Icon v-if="row.status == 1" type="ios-checkmark-circle-outline" color="#53C41A"/>
                                <span v-if="row.status == 1" style="color: #53C41A;">{{row.status_text}}</span>
                                <Icon v-if="row.status == 2" type="ios-close-circle-outline" color="#FF4838"/>
                                <span v-if="row.status == 2" style="color: rgb(255, 72, 56);">{{row.status_text}}</span>
                            </div>
                        </template>
                        <template slot-scope="{ index }" slot="operate">
                            <div class="flex-sa">
                                <Button type="error" ghost label="small" @click="goDel(index)">删除</Button>
                            </div>
                        </template>
                    </Table>
                </div>
                <div class="footer">
                    <Button @click="goDrawer">操作记录</Button>
                    <Button class="theme-bc ml-24" type="warning" @click="submitForm">确定</Button>
                </div>
            </Form>
        </div>
        <!-- 操作记录 -->
        <Drawer v-model="drawers" title="操作记录" width="80">
            <div>
                <div class="mb-24">
                    <Select class="width_15" v-model="pageDrawer.status" clearable filterable placeholder="状态查询">
                        <Option v-for="item in statusList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                    </Select>
                    <DatePicker class="width_15 mr-24 ml-24" type="daterange" split-panels @on-change="changeQrcodeDate" placement="bottom-start" placeholder="选择时间段" separator=" 至 "></DatePicker>
                    <Button class="theme-bc" icon="ios-search" type="warning" @click="goSearch">确认搜索</Button>
                </div>
                <Table :columns="columnsDrawer" :data="dataDrawer" border>
                    <template slot-scope="{ row }" slot="product_name">
                        <div>{{row.product ? row.product.product_name : ''}}</div>
                    </template>
                    <template slot-scope="{ row }" slot="batch_name">
                        <div>{{row.batch ? row.batch.batch_name : ''}}</div>
                    </template>
                    <template slot-scope="{ row }" slot="agent_name">
                        <div>{{row.agent ? row.agent.agent_name : ''}}</div>
                    </template>
                    <template slot-scope="{ row }" slot="start_id">
                        <div v-if="row.start_id">{{row.start_id}} - {{row.end_id}}</div>
                    </template>
                    <template slot-scope="{ row }" slot="warehouse">
                        <div>{{row.warehouse ? row.warehouse.name : ''}}</div>
                    </template>
                    <template slot-scope="{ row }" slot="nums">
                        <div>
                            <span :style="row.log.some(item => item.status == 2) ? '' : 'color: #53C41A;'">
                                {{row.log.reduce((nums, item) => {
                                    if (item.status === 1) {
                                        return nums + item.nums;
                                    }
                                    return nums;
                                }, 0)}}
                            </span>
                            <span style="color: #53C41A;">/{{row.nums}}</span>
                        </div>
                    </template>
                    <template slot-scope="{ row }" slot="status">
                        <div v-if="row.log.every(item => item.status == 1)" style="color: #53C41A;"><Icon type="ios-checkmark-circle-outline" color="#53C41A"/>操作成功</div>
                        <div v-else>
                            <div class="flex-c" v-if="row.log.some(item => item.status == 0)">
                                <img class="width_18" src="../../assets/loading.gif">
                                <span style="color: #FF761D;">等待中</span>
                            </div>
                            <div v-if="row.log.some(item => item.status == 2)" style="color: #FF4838;"><Icon type="ios-close-circle-outline" color="#FF4838"/>操作失败</div>
                        </div>
                    </template>
                    <template slot-scope="{ row }" slot="operate">
                        <div class="flex-sa" v-if="row.log.some(item => item.status == 2)">
                            <Button type="primary" ghost label="small" @click="goCheck(row)">查看</Button>
                            <Button type="primary" ghost label="small" @click="goRefresh(row)">重新操作</Button>
                        </div>
                    </template>
                </Table>
                <div class="mt-24 ta-r">
                    <Page :current="pageDrawer.page" :page-size="pageDrawer.limit" :total="totalDrawer" show-elevator show-total @on-change="pageDrawerChange"/>
                </div>
            </div>
        </Drawer>
        <!-- 查看 -->
        <Modal v-model="checkModal" title="查看" width="40">
            <div>{{reason}}</div>
            <div slot="footer"></div>
        </Modal>
    </div>
</template>

<script>
import { 
    warehouse_transfer, 
    warehouse_search, 
    warehouse_log, 
    warehouse_refresh, 
} from '@/api/index';
import { 
    product_select, 
    batch_select, 
    agent_select, 
    warehouse_select,
} from '@/api/select';
export default {
    data() {
        return {
            reason: "",
            code: '',
            formItem: {
                type: "1",
                product_id: "",
                batch_id: "",
                agent_id: "",
                start_id: "",
                end_id: "",
                warehouse_id: "",
                qrcode_number: [],
            },
            productList: [],
            batchList: [],
            agentList: [],
            warehouseList: [],
            columnsTable: [
                { type: 'index', width: 60, align: 'center' },
                { title: "产品图片", slot: "show_product_imgs", align: "center" },
                { title: "产品名称及规格", slot: "product_name", align: "center" },
                { title: "溯源码编码", key: "qrcode_number", align: "center" },
                { title: "关联批次", slot: "batch_name", align: "center" },
                { title: "关联箱码", slot: "box", align: "center" },
                { title: "当前仓库", slot: "warehouse_qrcode", align: "center" },
                { title: "码状态", slot: "status_text", align: "center" },
                { title: "操作", slot: "operate", align: "center" },
            ],
            dataTable: [],
            drawers: false,
            pageDrawer: {
                status: -1,
                page: 1,
                limit: 10,
                start_date: '',
                end_date: '',
            },
            totalDrawer: 0,
            columnsDrawer: [
                { type: 'index', width: 60, align: 'center' },
                { title: "产品名称", slot: "product_name", align: "center" },
                { title: "批次名称", slot: "batch_name", align: "center" },
                { title: "代理名称", slot: "agent_name", align: "center" },
                { title: "ID号段", slot: "start_id", align: "center" },
                { title: "仓库", slot: "warehouse", align: "center" },
                { title: "数量", slot: "nums", align: "center" },
                { title: "状态", slot: "status", align: "center" },
                { title: "操作时间", key: "created_at", align: "center", width: "170px" },
                { title: "操作", slot: "operate", align: "center", width: "200px" },
            ],
            dataDrawer: [],
            statusList: [
                { id: -1, name: "全部" },
                { id: 0, name: "等待中" },
                { id: 1, name: "操作成功" },
                { id: 2, name: "操作失败" },
            ],
            checkModal: false,
        };
    },
    mounted() {
        this.getProductSelect();
        this.getBatchSelect();
        this.getAgentSelect();
        this.getWarehouseSelect();
    },
    methods: {
        // 调拨日志
        getWarehouseLog(){
            warehouse_log(this.pageDrawer).then((res) => {
                this.dataDrawer = res.data.data;
                this.totalDrawer = res.data.total;
            })
            .catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        goSearch(){
            this.getWarehouseLog();
        },
        getProductSelect(){
            product_select().then((res) => {
                this.productList = res.data;
            })
            .catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        getBatchSelect(){
            batch_select().then((res) => {
                this.batchList = res.data;
            })
            .catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        getAgentSelect(){
            agent_select().then((res) => {
                this.agentList = res.data;
            })
            .catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        getWarehouseSelect(){
            warehouse_select().then((res) => {
                this.warehouseList = res.data;
            })
            .catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        // 查询溯源码
        getWarehouseSearch() {
            warehouse_search({ code: this.code }).then((res) => {
                this.dataTable = res.data;
            })
            .catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        goDel(index){
            this.dataTable.splice(index, 1);
        },
        pageDrawerChange(index) {
            this.pageDrawer.page = index;
            this.getWarehouseLog();
        },
        searchInput(e){
            if(e){
                this.code = e;
                this.getWarehouseSearch();
            }
        },
        submitForm(){
            var dataTable = this.dataTable;
            this.formItem.qrcode_number = dataTable.map(item => (
                item.qrcode_number
            ))
            warehouse_transfer(this.formItem).then((res) => {
                this.$Message.success(res.msg);
            })
            .catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        goDrawer(){
            this.getWarehouseLog();
            setTimeout(() => {
                this.drawers = true;
            }, 300);
        },
        changeQrcodeDate(e){
            if(e[0]){
                this.pageDrawer.start_date = e[0];
                this.pageDrawer.end_date = e[1];
            }else {
                this.pageDrawer.start_date = '';
                this.pageDrawer.end_date = '';
            }
        },
        // 重新操作
        goRefresh(row){
            warehouse_refresh({id: row.id}).then((res) => {
                this.$Message.success(res.msg);
            })
            .catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        goCheck(row){
            this.reason = row.log[0].reason;
            this.checkModal = true;
        },
    },
};
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
}
.content {
    padding: 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
    height: 100%;
}
.footer {
    margin: 24px 0 0 0;
    padding: 24px 0 0 0;
    text-align: center;
    border-top: 1px solid #eee;
}
.width_60 {
    width: 60px;
    height: 60px;
}
::v-deep .ivu-input-search {
    background: #53C41A !important;
    border-color: #53C41A !important;
}
::v-deep .ivu-radio-group-button .ivu-radio-wrapper-checked {
    background: #53C41A;
    border-color: #53C41A;
    box-shadow: -1px 0 0 0 #53C41A;
    border-radius: 5px;
    color: #fff;
    z-index: 1;
}
::v-deep .ivu-checkbox{
    margin-right: 24px;
}
::v-deep .ivu-checkbox-checked .ivu-checkbox-inner {
    border-color: #ff761d;
    background-color: #ff761d;
}
/* 表头背景颜色 */
::v-deep .ivu-table-header thead tr th {
    background: rgba(198, 44, 44, 0) !important;
    box-shadow: 0px 1px 0px 0px rgba(234, 234, 234, 0.99);
}
/* 表头字体颜色 */
::v-deep .ivu-table-wrapper .ivu-table .ivu-table-header tr th {
    color: #484e66 !important;
    font-weight: bold;
}
/* table中所有的边框  */
::v-deep .ivu-table td {
    border-left: none;
    border-right: none;
}
::v-deep .ivu-table th {
    border-left: none;
    border-right: none;
}
.width_10 {
    width: 10vw;
}
.table_div {
    max-height: 510px;
    overflow-y: auto;
}
.width_15 {
    width: 15vw;
}
.width_18 {
    width: 18px;
    height: 18px;
}
.w400 {
    width: 400px;
}
.ta-r {
    text-align: right;
}
</style>